import { error } from '../helpers/notyf';

/**
 * Detailed error for status 
 * 403 when user does not have permissions
 * 401 when user is not authenticated (redirect to login)
 * 
 * Handle auth error 
 * when login is unsucessfull then throw an error 
 * if backend does nto provide one
 * 
 * @param {*} er 
 * @returns 
 */
export const handleAuthError = er => {
  const status = er?.response?.data.status;
  const data = er?.response?.data;

  if (status === 403) {
    error(data?.message || 'Your account is not allowed to login.');
    return;
  }

  if (status === 401) {
    error(data);
    window.location.replace('/login');
    return;
  }

  error(data || 'Unexpected error');
};